import React from "react";
import { router } from "expo-router";

import { ProfileInformationForm } from "@/blocks/ProfileInformationForm";
import { ScreenLayout } from "@/blocks/ScreenLayout";
import { VnBox } from "@/components/VnBox";
import { VnButton } from "@/components/VnButton/VnButton";
import { VnForm } from "@/components/VnForm";
import { VnScrollView } from "@/components/VnScrollView";
import { VnText } from "@/components/VnText/VnText";
import { useUpdateHouseholdMemberMutation } from "@/data/mutations/householdMembersMutations";
import { useListHouseholdMembersQuery } from "@/data/queries/householdMembersQueries";
import { HouseholdMemberFormType } from "@/domain/householdMember";
import { useProfileInformationForm } from "@/hooks/useProfileInformationForm";
import { cleanHouseholdMemberFormData } from "@/utils/householdMember";

export const RegistrationProfileScreen = () => {
  const { data: householdMembers, isLoading } = useListHouseholdMembersQuery();
  const currentHouseholdMember = householdMembers?.[0];
  const { mutateAsync: updateHouseholdMember } =
    useUpdateHouseholdMemberMutation();

  const { form } = useProfileInformationForm({
    isPrimaryMember: Boolean(currentHouseholdMember?.patientId),
  });

  const handleSubmit = async (formData: HouseholdMemberFormType) => {
    if (!currentHouseholdMember?.id) {
      return;
    }

    const cleanedData = cleanHouseholdMemberFormData(formData);

    await updateHouseholdMember(
      {
        id: currentHouseholdMember.id,
        householdMemberData: cleanedData,
      },
      {
        onSuccess: () => {
          router.navigate("/(authed)/registration/consent-form");
        },
      },
    );
  };

  return (
    <VnBox className="bg-background flex-1">
      <VnScrollView>
        <VnBox className="border-border bg-secondary mx-auto my-6 w-[90%] max-w-lg rounded-lg border py-5">
          <ScreenLayout variant="FORM" backgroundClassName="bg-secondary">
            <VnBox className="px-2">
              <VnText
                variant="headerTwo"
                i18nKey="native:householdMemberScreen.profileInformation"
              />
              <VnText
                variant="lg"
                className="text-muted-foreground mb-6 mt-2"
                i18nKey="native:registrationProfileScreen.description"
              />
              <VnForm form={form} isInputOnlyForm>
                <ProfileInformationForm
                  householdMember={currentHouseholdMember}
                  isLoading={isLoading}
                  showIdentificationFields={false}
                />
                <VnButton
                  className="container mx-auto w-full"
                  i18nKey="common:next"
                  onPress={() => {
                    void form.handleSubmit(handleSubmit)();
                  }}
                />
              </VnForm>
            </VnBox>
          </ScreenLayout>
        </VnBox>
      </VnScrollView>
    </VnBox>
  );
};
